<mat-tab-group
  class="quickpanel"
  fxFlex
>
  <mat-tab>
    <ng-template mat-tab-label>
      <div class="alert-header">
        ALERTS
        <button
          mat-icon-button
          class="pulse-button s-30-btn"
          aria-label="pulse"
          (click)="gotoSettings()"
        >
          <i class="icon icon-pulse"></i>
        </button>
      </div>
    </ng-template>
    <fury-scrollbar
      class="overflow-container"
      fxFlex="auto"
    >
      @for (alert of alerts | orderBy : '-isCritical'; track alert.id) { @switch (alert.alertType) {
      @case ('ScheduleSlip') {
      <app-alert-schedule-slip [alert]="alert"></app-alert-schedule-slip>
      } @case ('WarehouseTaskLate') {
      <app-alert-warehouse-late [alert]="alert"></app-alert-warehouse-late>
      } @case ('IntegrationError') {
      <app-alert-integration-error [alert]="alert"></app-alert-integration-error>
      } @case ('TruckLate') {
      <app-alert-truck-late [alert]="alert"></app-alert-truck-late>
      } @case ('OrderLate') {
      <app-alert-truck-late [alert]="alert"></app-alert-truck-late>
      } @case ('Licensing') {
      <app-alert-licensing [alert]="alert"></app-alert-licensing>
      } @default {
      <app-alert-general [alert]="alert"></app-alert-general>
      } } }
    </fury-scrollbar>
  </mat-tab>
</mat-tab-group>
